var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import { editingMode } from 'sdc-cms-writing';
import { fieldValue } from 'sdc-data-models';
import { MarkdownPanel } from 'sdc-markdown-viewer';

import './MarkdownView.scss';

var MarkdownView = inject('editingStore', 'indexStore')(observer(function (_ref) {
  var store = _ref.editingStore,
      indexStore = _ref.indexStore,
      ignoreIndex = _ref.ignoreIndex,
      field = _ref.field,
      show = _ref.show,
      editStyle = _ref.editStyle,
      labelStyle = _ref.labelStyle,
      viewStyle = _ref.viewStyle,
      mdv = _ref.mdv,
      props = _objectWithoutProperties(_ref, ['editingStore', 'indexStore', 'ignoreIndex', 'field', 'show', 'editStyle', 'labelStyle', 'viewStyle', 'mdv']);

  if (editingMode.isEditMode.get() && !show) return null;
  if (field.display !== 'markdown') return null;

  var text = field.localize && store.currentLocale !== undefined ? (fieldValue(store._sending, field.key) || {})[store.currentLocale.key] || '' : fieldValue(store._sending, field.key) || '';
  if (!text) return null;

  return React.createElement(
    'div',
    _extends({ className: 'markdown-panel', style: viewStyle }, props),
    React.createElement(MarkdownPanel, _extends({ text: text, ignoreIndex: ignoreIndex }, mdv))
  );
}));
export { MarkdownView };